import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { blackBackArrowImage } from "../../assets";
import { googleApiKey, invokeApi } from "../../bl_libs/invokeApi";
import GoogleMaps from "./components/GoogleMaps";

import { withScriptjs } from "react-google-maps";
function TrackingLocation(props) {
  const [requestData, setRequestData] = useState();

  const [isLoading, setIsLoading] = useState(true);
  const [errMessage, setErrMessage] = useState("");

  const [liveLocation, setLiveLocation] = useState("");

  const pushUrl = (url) => {
    props.history.push(url);
  };

  const fetchRequestDetails = (req_Id) => {
    let requestObj = {
      path: "/api/customer/customer_request_detail",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${req_Id}`,
    };

    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log("RESPONSE", res);
      if (res.code === 200) {
        //check and verify status of request is 2 (pending acceptance)
        //if not redirect to listing request
        // if (res.request.request_timeline_status !== 2) {
        //   pushUrl("/dashboard/my-requests");
        //   return;
        // }
        setRequestData(res);
        setIsLoading(false);
      } else {
        setErrMessage(res.message);
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    fetchRequestDetails(props.match.params.requestId);

    // navigator.geolocation.getCurrentPosition(
    //   (data) => {
    //     console.log(data, "123T");
    //     setTimeout(() => {
    //       setLiveLocation({
    //         lat: data.coords.latitude,
    //         lng: data.coords.longitude,
    //         // lat: 30.69196570169014,
    //         // lng: 73.09636655029297,
    //       });
    //     }, 3000);
    //   },

    //   (err) => console.log(err)
    // );

    // setTimeout(() => {
    //   setLiveLocation({
    //     // lat: data.coords.latitude,
    //     // lng: data.coords.latitude,
    //     // lat: 30.69196570169014,
    //     // lng: 73.09636655029297,
    //   });
    // }, 3000);
  }, []);
  if (isLoading) {
    return <>loading</>;
  }

  const MapLoader = withScriptjs(GoogleMaps);

  return (
    <section id="content-wrapper" className="content-wrapper rating-page">
      <div className="container-fluid">
        {/* <p className="small-text-bold page-title ">
          <img
            className="pointer-point"
            src={blackBackArrowImage}
            onClick={() => props.history.goBack()}
          />
          <span>Request DETAIL</span>
        </p> */}

        <div className="rating-wrapper mt-40 mt-m-30">
          <MapLoader
            address={requestData.request_address}
            liveLocation={liveLocation}
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places`}
            loadingElement={<div style={{ height: `100%`, width: "100%" }} />}
          />
        </div>
      </div>
    </section>
  );
}

export default withRouter(TrackingLocation);
